import Vue from 'vue/dist/vue.esm';
import axios from 'common/axios';
import RecommendsList from 'components/events/recommends/recommends_list.vue';

document.addEventListener('DOMContentLoaded', () => {
  const eventID = JSON.parse(document.getElementById('recommends').dataset.eventId);

  new Vue({
    el: '#recommends',
    components: { RecommendsList },
    data: {
      events: [],
      currentEvent: null
    },
    computed: {
      eventId: function() {
        return eventID;
      },
      recommendsPath: function() {
        return '/events/' + this.eventId + '/recommends';
      }
    },
    created: function() {
      this.loadRecommends();
    },
    methods: {
      loadRecommends: function() {
        axios.get(this.recommendsPath, {
          params: {
            format: 'json'
          }
        }).then((response) => {
          this.events.push(...response.data.events);
          this.currentEvent = response.data.current_event;
        });
      }
    },
    template: `
      <div>
        <recommends-list
          :currentEvent='currentEvent'
          :events='events'
        >
        </recommends-list>
      </div>
    `
  });
});
